import { useSettings } from "@/hooks/useSettings";

// Company logo: shows uploaded logo if present, otherwise the branded "M" mark + wordmark.
export default function Brand({ height = 36, textClass = "hidden font-display text-lg font-extrabold tracking-tight sm:block", showText = true }) {
  const { settings } = useSettings();
  const logo = settings?.logo;
  if (logo) {
    return <img src={logo} alt="MANHA DIGITAL" style={{ height }} className="w-auto max-w-[190px] object-contain" data-testid="site-logo" />;
  }
  return (
    <>
      <span className="grid shrink-0 place-items-center rounded-lg bg-primary font-display font-extrabold text-primary-foreground" style={{ height, width: height }}>M</span>
      {showText && <span className={textClass}>MANHA <span className="text-primary">DIGITAL</span></span>}
    </>
  );
}
